/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Creder } from './Creder';
import {
    CrederFromJSON,
    CrederFromJSONTyped,
    CrederToJSON,
} from './Creder';

/**
 * 
 * @export
 * @interface UpdateCrederRequest
 */
export interface UpdateCrederRequest {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof UpdateCrederRequest
     */
    workflowInstanceId: string;
    /**
     * 
     * @type {Creder}
     * @memberof UpdateCrederRequest
     */
    creder: Creder;
}

/**
 * Check if a given object implements the UpdateCrederRequest interface.
 */
export function instanceOfUpdateCrederRequest(value: object): boolean {
    if (!('workflowInstanceId' in value)) return false;
    if (!('creder' in value)) return false;
    return true;
}

export function UpdateCrederRequestFromJSON(json: any): UpdateCrederRequest {
    return UpdateCrederRequestFromJSONTyped(json, false);
}

export function UpdateCrederRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCrederRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'],
        'creder': CrederFromJSON(json['creder']),
    };
}

export function UpdateCrederRequestToJSON(value?: UpdateCrederRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'creder': CrederToJSON(value['creder']),
    };
}

